import { render, staticRenderFns } from "./TsJobsSearchCard.vue?vue&type=template&id=1252b07d"
import script from "./TsJobsSearchCard.vue?vue&type=script&lang=ts"
export * from "./TsJobsSearchCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports